import { Navigate } from 'react-router-dom';

/**
 * Legacy entry point for the standalone badges page. The reader-facing
 * "creatures" surface moved onto `/list` alongside the reading-list
 * grid, so any lingering link / bookmark to `/readers/:id/badges` now
 * redirects there.
 *
 * Kept as a file (rather than deleted) so the route stays importable in
 * App.tsx without breaking a stale git history. Safe to delete once the
 * redirect has been live long enough that no one uses the old URL.
 */
export function ReaderBadgesPage() {
  return <Navigate to="/list" replace />;
}
